import { createStyles, Theme } from '@material-ui/core';
import get from 'lodash/get';
import omit from 'lodash/omit';

import { styleFormIoComponent } from '#web-components/styles/form';
import { COMPONENT_CLASSES } from '../../constants';

const radioSelector = `.${COMPONENT_CLASSES.radio}`;

export default (theme: Theme) => createStyles({
  '@global': {
    [radioSelector]: {
      ...get(styleFormIoComponent(COMPONENT_CLASSES.radio, theme), radioSelector, {}),
      '& label.col-form-label, & span.col-form-label': {
        ...theme.typography.textRegular,
        display: 'inline-block',
        marginBottom: theme.spacing(1),
        color: theme.colors.text.primary,
      },
      '& .MuiFormControlLabel-label.Mui-disabled': {
        color: theme.colors.text.subtle,
      },
    },
    ...omit(styleFormIoComponent(COMPONENT_CLASSES.radio, theme), radioSelector),
  },
});
